import { useTranslation } from 'react-i18next'
import { Alert } from '~/shared/ui/Alerts'
import { Button } from '~/shared/ui/Buttons'
import { Modal } from '~/shared/ui/Modal'

type WarningCannotCreateModalProps = {
  isShow: boolean
  onCancel: () => void
}

export function WarningCannotCreateModal({
  isShow,
  onCancel,
}: WarningCannotCreateModalProps) {
  const { t } = useTranslation()
  return (
    <Modal isShow={isShow} onCancel={onCancel}>
      <Alert variant='warning' sx={{ margin: '44px 0 24px 0' }}>
        {t('alert.creating a contract is only possible after driver approval')}
      </Alert>

      <Button variant='gray' fullWidth onClick={onCancel}>
        {t('button.close')}
      </Button>
    </Modal>
  )
}
